<template>
  <div v-if="$route.query.verification_code" class="position-fixed" style="bottom: 50%;margin-bottom: -5rem;right: 50%;margin-right: -5rem">
    <AppSpinner class="text-secondary" size="10" />
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  import {verifyEmail} from "../../api/userEmail.api";
  import AppSpinner from "../../components/common/utils/AppSpinner";

  export default {
    name: "EditEmailCallback",
    components: {AppSpinner},
    created() {
      if (!this.$route.query.verification_code) {
        this.$router.push("/");
      } else {
        verifyEmail(this.$route.query.verification_code).then(
          () => {
            this.$snotify.success(
              this.$t(this.$getConst.pages.alerts.redirecting_to_login_page),
              this.$t(this.$getConst.pages.alerts.success_operation),
            );
            this.goSignIn()
          },
          (error) => {
            if (error.response.data.error === "This email already exists in azure") {
              this.$snotify.error(
                this.$t(this.$getConst.pages.alerts.redirecting_to_login_page),
                this.$t(this.$getConst.pages.alerts.existing_email),
              )
            } else {
              const errorBody = this.resolveErrorMessage(error);
              this.$snotify.error(
                this.$t(this.$getConst.pages.alerts.redirecting_to_login_page),
                errorBody.message
              );
            }
            this.goSignIn();
          }
        );
      }
    },
    methods: {
      goSignIn() {
        let self = this;
        setTimeout(
          function () {
            self.$store.dispatch("auth/logout")
          },
          5000
        )
      }
    }
  }
</script>

<style scoped>

</style>
